import EditSectionModal from "../../components/EditSectionModal";
import { getAllWorkouts, updateWorkoutsSection } from "../../services/workouts";

const EditWorkoutSectionModal = function () {
  return (
    <EditSectionModal
      config={{
        entityName: "Workout",
        entityNamePlural: "Workouts",
        fetchItems: getAllWorkouts,
        saveSection: updateWorkoutsSection,
        responseKey: "data",
      }}
    />
  );
};

export default EditWorkoutSectionModal;
